const styles = theme => ({
  container: {
    lineHeight: 2,
    "& .title h2": {
      fontWeight: 600,
      marginBottom: 10, 
      textTransform: 'uppercase',
      textAlign: 'center',
    },
    "& > div": {
      lineHeight: 1.5
    }, 

    "& img": {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 20,
      marginBottom: 20
    },

    "& ul": {
      listStyle: 'initial',
      margin: 'initial',
      padding: '0 0 0 40px'
    },

    "& li": {
      listStyle: 'disc',
    }
  }
});

export default styles;